export default __webpack_public_path__ + "static/app-teacher-7b50341fd6c4c5f7463e3469afb37449.png";